import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledHighlihtedValue = styled(Box, {
  fontSize: '$3xl',
  fontWeight: '$bold',
  lineHeight: '$8',
  margin: '$0',
});

export const StyledValue = styled('b', {
  color: '$darkBlue400',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyledLabel = styled(Box, {
  display: 'block',
  textTransform: 'uppercase',
  color: '$darkGray300',
  fontSize: '$xs',
  fontWeight: '$regular',
  lineHeight: '$4',
  letterSpacing: '0.5px',
  variants: {
    fontSize: {
      lg: {
        fontSize: '$lg',
      },
      md: {
        fontSize: '$md',
      },
      sm: {
        fontSize: '$sm',
      },
      xs: {
        fontSize: '$xs',
      },
    },
  },
});
